export default __webpack_public_path__ + "static/media/Hibiscus Conditioner - Front - (S-11)1.90a8251c.jpg";